/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, formValueSelector, reduxForm, reset } from 'redux-form';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import { renderAutoCompleteMultipleSelection, renderAutoCompleteScheduling, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../components/reduxFields';
import { getOrganizationBillableHoursGraph } from '../modules/Dashboards/actions/StaffDashboardActions';
import moment from 'moment';
import Slider from 'react-rangeslider'
import {getTrendLine, getTrendData, getAverageLine} from '../chartUtils/utlis';
Exporting(Highcharts);
ExportingData(Highcharts);
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class KPIBillableHours extends Component {

  constructor(props) {
    super(props);        
    this.state = {            
        sliderMaxValue: 100,
        sliderValue: 100,        
        xAxisDateOption: [],  
        isReset: false,
        averageLine:[]
       };
  }

  // loadOrganizationBillableHoursGraph() {
  //   let searchObj3 = {
  //     contain_filters: {
  //       fromDate: this.state.FromBillableHoursDate ? moment(this.state.FromBillableHoursDate).format('YYYY-MM-DD') : new Date(),
  //       toDate: this.state.ToBillableHoursDate ? moment(this.state.ToBillableHoursDate).format('YYYY-MM-DD') : new Date(),
  //       payerIds: [],
  //       appointmentTypeIds: [],
  //       staffIds: [],
  //       patientIds: [],
  //       locationIds: [],
  //       //IsBillable: isBillable ? true : false, 
  //     }, 
  //   };
  //   this.props.getOrganizationBillableHoursGraph(searchObj3);
  // }

  componentDidMount = () => {
    this.highchartsHandler();
  }

  componentDidUpdate = () => {
      if(this.props.dataAnalytics !== null) {
          this.highchartsHandler();
      }
  }

  handleReset = () => {
    this.props.dispatch(reset('KPIBillableHoursForm'));    
    this.props.handleResetBillableKPI();
  };

  highchartsHandler = () => {
    let finalData = [];
    let billableHourId = [];
    let xAxisDateBeforeSorting = [];
    let xAxisDate = [];
    let xAxisLabel = 'Billable Hours';    
    let yAxisLabel = 'Date';
    let disableLegend = this.props.disableLegend;
    let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
    
    let  avgPlotLine = {}; //seriesSum = 0, seriesCount = 0,
    let totalhours = 0;
    let plotLines = [];
    
    
    



    if (this.props.dataAnalytics !== null && this.props.dataAnalytics.data != null && this.props.dataAnalytics.data.patientBillableHoursGraphs != null && this.props.dataAnalytics.data.patientBillableHoursGraphs.length > 0) {
        this.props.dataAnalytics.data.patientBillableHoursGraphs.map((obj, index) => {

          if(obj.reportType === 'ByMonth')
          {
            let dataObj = {}
            let billableHours = [];
            let billableHoursdataForDate = this.props.dataAnalytics.data.patientBillableHoursGraphs;
            for (let i = 0; i < billableHoursdataForDate.length; i++) {
                if(xAxisDateBeforeSorting.indexOf(moment(billableHoursdataForDate[i].dateOfService).format('MMM/yyyy')) === -1)
                {
                    xAxisDateBeforeSorting.push(moment(billableHoursdataForDate[i].dateOfService).format('MMM/yyyy'));
                }
            }

            xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

            for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
            {  
                xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MMM/yyyy');
            }

            if(billableHourId.indexOf(obj.billableHourId) === -1)
            {
                let appointmentdata = this.props.dataAnalytics.data.patientBillableHoursGraphs.filter((op) => op.billableHourId === obj.billableHourId);
                billableHours = [];
                for (let i = 0; i < appointmentdata.length; i++) {
                    dataObj['name'] = appointmentdata[i].title;
                    dataObj['billableHourId'] = appointmentdata[i].billableHourId;
                    billableHourId.push(appointmentdata[i].billableHourId);
                    if(xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MMM/yyyy')) > -1)
                    {
                        let index = xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MMM/yyyy'));
                        billableHours[index] = parseFloat(appointmentdata[i].y);
                        totalhours = totalhours + parseFloat(appointmentdata[i].y);
                        // billableHours.push(appointmentdata[i].billableHours);
                        // seriesSum += parseFloat(appointmentdata[i].billableHours);
                        // seriesCount += 1;
                    }
                }

                for(let j = 0; j < xAxisDate.length; j++)
                {
                    //if(!billableHours[j])
                    if(billableHours[j] === undefined || billableHours[j] < 0)
                    {
                      billableHours[j] = null;
                    }
                }
                
                if (this.state.sliderMaxValue !== Math.max(...billableHours)) {                    
                    this.setState({sliderMaxValue: Math.max( ...billableHours), sliderValue: Math.max( ...billableHours)});                        
                }
                dataObj['data'] = billableHours;
                finalData.push(dataObj);
            }
          }
          else {
            let dataObj = {}
            let billableHours = [];
            let billableHoursdataForDate = this.props.dataAnalytics.data.patientBillableHoursGraphs;
            for (let i = 0; i < billableHoursdataForDate.length; i++) {
                if(xAxisDateBeforeSorting.indexOf(moment(billableHoursdataForDate[i].dateOfService).format('MM/DD/YYYY')) === -1)
                {
                    xAxisDateBeforeSorting.push(moment(billableHoursdataForDate[i].dateOfService).format('MM/DD/YYYY'));
                }
            }

            xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

            for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
            {  
                xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MM/DD/YYYY');
            }

            if(billableHourId.indexOf(obj.billableHourId) === -1)
            {
                let appointmentdata = this.props.dataAnalytics.data.patientBillableHoursGraphs.filter((op) => op.billableHourId === obj.billableHourId);
                billableHours = [];
                for (let i = 0; i < appointmentdata.length; i++) {
                    dataObj['name'] = appointmentdata[i].title;
                    dataObj['billableHourId'] = appointmentdata[i].billableHourId;
                    billableHourId.push(appointmentdata[i].billableHourId);
                    if(xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MM/DD/YYYY')) > -1)
                    {
                        let index = xAxisDate.indexOf(moment(appointmentdata[i].dateOfService).format('MM/DD/YYYY'));
                        billableHours[index] = parseFloat(appointmentdata[i].y);
                        totalhours = totalhours + parseFloat(appointmentdata[i].y);
                        // billableHours.push(appointmentdata[i].billableHours);
                        // seriesSum += parseFloat(appointmentdata[i].billableHours);
                        // seriesCount += 1;
                    }
                }

                for(let j = 0; j < xAxisDate.length; j++)
                {
                    //if(!billableHours[j])
                    if(billableHours[j] === undefined || billableHours[j] < 0)
                    {
                      billableHours[j] = null;
                    }
                }
                
                if (this.state.sliderMaxValue !== Math.max(...billableHours)) {                    
                    this.setState({sliderMaxValue: Math.max( ...billableHours), sliderValue: Math.max( ...billableHours)});                        
                }
                dataObj['data'] = billableHours;
                finalData.push(dataObj);
            }
          }
            


        });

    }

    if(xAxisDate.length && this.state.xAxisDateOption.length != xAxisDate.length)
      {
          let xAxisDate1 = [];

          xAxisDate1 = xAxisDate.map((d,i)=>{
              return {
                  'id':i,
                  'value':d.toString()
              }
          })

          this.setState({xAxisDateOption: xAxisDate1}
              ,()=>{ this.setState({})}
              );           
      }


    finalData.reverse();
    
    ////////////////////////////////////

    function formatSecondsToDate(seconds) {
      const date = new Date(new Date(seconds).toUTCString());
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1;
      let year = date.getUTCFullYear();

      let formattedMonth = month < 10 ? `0${month}` : `${month}`;
      let formattedDay = day < 10 ? `0${day}` : `${day}`;

      let formattedDate = `${formattedMonth}/${formattedDay}/${year}`;
      return formattedDate;
    }
  
    function modifyMulArrToSingleWithYAxis(arr,length,type){
      let updatedArr = [];
      if(type=="trendline" && arr.length){
        let emptyArry = new Array(length).fill(null);
        emptyArry[0] = parseFloat(arr[0][1].toFixed(2));
        emptyArry[length-1] = parseFloat(arr[1][1].toFixed(2));
        updatedArr = emptyArry;
      }else if(arr.length){
        for(let i=0;i<length;i++){
          if(arr[i] && arr[i][1] != null && arr[i][1] != undefined){
            updatedArr.push(parseFloat(arr[i][1].toFixed(2)))
          }else {
            updatedArr.push(null);
          }
        }
      }
      return updatedArr;
    }

    let chartData = [];
    let trendData = [];
    let averageLine = [];
    let trendLine = [];
    let singleAvg =[];
    let lineChartTooltipName = "Total Hour(s)"
    let isFinalChart = false;
    let isOtherLineChart = false;
    if(this.props.dataAnalytics !== null && this.props.dataAnalytics.data != null && this.props.dataAnalytics.data.patientBillableHoursGraphs != null && this.props.dataAnalytics.data.patientBillableHoursGraphs.length > 0) {
        let graphHoursData = this.props.dataAnalytics.data.patientBillableHoursGraphs;
        trendData = getTrendData(graphHoursData, "y","dateOfService");
        averageLine = getAverageLine(trendData);
        singleAvg = averageLine[0][1];
        plotLines = []
        // console.log("trendData",trendData);
        // console.log("averageLine",averageLine);
        trendLine = getTrendLine(trendData);
        let avgD = {};
          if(averageLine){    
              let length = averageLine.length;
              let newArray = new Array(length);
              let sAvg = parseFloat(singleAvg)
              let filledArray = newArray.fill(null);
              filledArray[0] = sAvg;
              filledArray[newArray.length-1] = sAvg;
              avgD = filledArray;
              averageLine = avgD;
          }
      }
  



    if(this.props.showTrendChart && !this.props.showDisplayAverage){
      isFinalChart = false;
      isOtherLineChart = true;
      chartData = [];
      chartData.push(
          {
            // type: 'scatter',
            type: 'line',
            name: lineChartTooltipName,
            data: modifyMulArrToSingleWithYAxis(trendData,trendData.length), 
            marker: {
                radius: 4
            }
        },
        {
        
          type: 'line',
          name: 'Trend Line',
          data: modifyMulArrToSingleWithYAxis(trendLine,trendData.length,"trendline"),
          value: 454,
          width: 2,
          marker: {
              enabled: false
          },
          dashStyle: 'longdash',
          color:"#000000"
        }
      );
      xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a));      
    }else if(this.props.showDisplayAverage && !this.props.showTrendChart){
      
      isOtherLineChart = true;
      isFinalChart = false;
      chartData = [];

      plotLines.push({
        color:"#000000",
        width: 2,
        value: [singleAvg],
        zIndex: 4,
        dashStyle: 'Dash',
        label: {
          text: singleAvg && singleAvg != 0 ? `${singleAvg} Avg`:'',
          align: 'right',
          x: 0,
          y: -10
      }
    });

      chartData.push(
          {
            // type: 'scatter',
            type: 'line',
            name: lineChartTooltipName,
            data: modifyMulArrToSingleWithYAxis(trendData,trendData.length), 
            marker: {
                radius: 4
            }
        },
        {
          type: 'line',
          name: 'Average Line',
          data: averageLine,
          width: 2,
          marker: {
            enabled: false
          },
          color: 'transparent',
          dashStyle: 'shortdash',
        }
      );
      xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a));
    }else if(this.props.showTrendChart && this.props.showDisplayAverage){
      isOtherLineChart = true;
      isFinalChart = false;
      chartData = [];
      plotLines.push({
        color:"#000000",
        width: 2,
        value: [singleAvg],
        zIndex: 4,
        dashStyle: 'Dash',
        label: {
          text: singleAvg && singleAvg != 0 ? `${singleAvg} Avg`:'',
          align: 'right',
          x: 0,
          y: -10
      }
    });
      chartData.push(
        {
          // type: 'scatter',
          type: 'line',
          name: lineChartTooltipName,
          data: modifyMulArrToSingleWithYAxis(trendData,trendData.length), 
          marker: {
              radius: 4
          }
      },
      {
      
        type: 'line',
        name: 'Trend Line',
        data: modifyMulArrToSingleWithYAxis(trendLine,trendData.length,"trendline"),
        width: 2,
        marker: {
            enabled: false
        },
        dashStyle: 'longdash',
        color:"#000000"
      },{
        type: 'line',
        name: 'Average Line',
        data: averageLine,
        width: 2,
        marker: {
          enabled: false
        },
        color: 'transparent',
        dashStyle: 'shortdash',
      }
    );
    xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a));
    }else{
      isOtherLineChart = false;
      isFinalChart = true;
      chartData = finalData;
    }
    ////////////////////////////////////


    Highcharts.setOptions({
        lang: {
          thousandsSep: ','
        },
        colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
    });
    Highcharts.chart('analyticsDataDivBillableHours', {

        title: {
            text: 'Total Hour(s): ' + totalhours.toFixed(2)
        },
        //annotations: this.state.AnnotationLabel,
        yAxis: {
            gridLineWidth: gridlinesWidth,
            minorGridLineWidth: gridlinesWidth,
            title: {
            text: `<b>${xAxisLabel}</b>`
            },
            labels: {
                enabled: true
            },
            min: 0,
            max: this.state.sliderValue,
            plotLines: plotLines
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            enabled: disableLegend,
        },

        xAxis: {
          ///////
            // type: isOtherLineChart && 'datetime', // Treat The X-axis as dates
          ///////
            title: {
                text: `<b>${yAxisLabel}</b>`,
            },
            tickLength: 0,
            categories: xAxisDate,
            labels: {
              enabled: true
            },
            // plotLines: plotLines,
        },

        credits: {
            enabled: false
        },

        plotOptions: {
            series: {
                cursor: 'pointer',
                connectNulls:true,
                //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                fillOpacity: 0.6,
                label: {
                    connectorAllowed: false
                },
                dataLabels: {
                    enabled: false
                },
                events: {
                    legendItemClick: function () {
                        return false
                    }
                },
                marker: {
                    enabled: true        
                }
            }
        },
//////////
        series: chartData,
/////////
        // series: [{
        //     name: 'Installation',
        //     data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
        // }, {
        //     name: 'Manufacturing',
        //     data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
        // }],

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        enabled: disableLegend,
                    }
                }
            }]
        },

        navigation: {
            buttonOptions: {
                verticalAlign: 'top',
                x: -100
            }
        },

        lang: {
            contextButtonTitle: 'Click to open'
        },

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                }
            },
            chartOptions: {
                colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
            }
        }
    });
}

  onSliderChange = (value) => {     
    this.setState({
        sliderValue: value
    },()=> this.highchartsHandler());
  }


  render() {
    let { sliderValue } = this.state
    //const { handleSubmit, OrganizationAuthorization } = this.props;
   // const authList =  (OrganizationAuthorization && OrganizationAuthorization.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
                <form className="readmin-form custom_form" >                
                  <div className="row end-flex">         
                    <div className="col-sm-3 ml-10">
                      <Field name="FromBillableHoursDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.props.FromBillableHoursDate}
                        onDateChange={this.props.onBillableKPIDateChange}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-3 ml-10">
                      <Field name="ToBillableHoursDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate = {this.props.FromBillableHoursDate}
                        selected={this.props.ToBillableHoursDate}
                        openToYearSelection={true}
                        onDateChange={this.props.onBillableKPIDateChange}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-3 ml-10 mt-35">
                        <Field name="billableLocationIds"
                          label="Location"
                          handleNewRequest={this.props.handleBillableChange}
                          options={this.props.userLocationList}
                          component={renderAutoCompleteScheduling}
                        />
                    </div>
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field name="billablePayerIds"
                        label="Payer"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.masterInsuranceCompanies}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>        
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field
                        name="billableAppointmentTypeIds"
                        label="Appointment Type"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.billableAppointmentType}
                        component={renderAutoCompleteScheduling} />
                    </div>       
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field name="billableStaffIds"
                        label="Staff"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.allStaffs}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>              
                    <div className="col-sm-3 ml-10 mt-35">
                      <Field
                        name="billablePatientIds"
                        label="Client"
                        handleNewRequest={this.props.handleBillableChange}
                        options={this.props.patientlist}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>
                    <div className="col-sm-3 mt-30">
                        <Field
                          name="byWeekOrMonth"
                          label="By Week Or Month"
                          handleNewRequest={this.props.handleBillableReportTypeChange}
                          options={this.props.ByWeekOrMonthList}
                          component={renderAutoCompleteSingleSelect}    
                          fullWidth={true}                      
                        />
                    </div>
                    <div className="col-sm-3 mt-30">
                      <Field
                        name="tags" 
                        label="Client and Staff Tags"
                        handleNewRequest={this.props.handleTagChange}
                        options={this.props.masterTagsForAll}
                        component={renderAutoCompleteMultipleSelection} />
                    </div>
                    <div className="col-sm-3 mt-30">
                      <Field
                          name="ExcludeTag"
                          label="Exclude Tags"
                          component={renderCheckBox}
                          onChange={(e) => this.props.isExcludeTagHandler(e)}
                        />
                    </div>
                    <div className="col-sm-3 mt-30">
                      <Field
                        name="ShowTrendChart"
                        label="Display Trendlines"
                        component={renderCheckBox}
                      />
                    </div>
                    <div className="col-sm-3 mt-30">
                      <Field
                        name="ShowDisplayAverage"
                        label="Display Average"
                        component={renderCheckBox}
                      />
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
                </form>    
          </div>
        </div>
        <div className='row'>
            <div className='col-sm-auto'>
                <Slider 
                    min={0}
                    max={this.state.sliderMaxValue}                           
                    value={sliderValue}
                    orientation="vertical"
                    onChange={(e)=>this.onSliderChange(e)}
                    tooltip={false}
                />
            </div>
            <div className='col-sm-11'>
              {
                  this.props.loading ? "Loading..." :
                  <div>
                    {/* {this._returnGraphBasedOnCheckbox(this.props.showTrendChart)} */}
                    <div>
                      {/* { this.props.showTrendChart && <TrendlineGraph dataAnalytics={this.props.dataAnalytics} sliderValue={this.state.sliderValue}/>} */}
                      { this.state.xAxisDateOption.length > 0 ? 
                      <div className='row'>                          
                          <div className='col-sm-6'></div>
                      </div>   
                      : null}
                      <div id='analyticsDataDivBillableHours' style={{ height: '500px' }} /> 
                    </div>
                  </div>
              }
            </div>
          </div>        
      </div>
    );
  }
}
//////////////
const initialValues = {
  ShowTrendChart:false,
  ShowDisplayAverage:false,
}
//////////

KPIBillableHours = reduxForm({
  form: 'KPIBillableHoursForm',
  ///////////////
  initialValues
  /////////////
})(KPIBillableHours);

const selector = formValueSelector('KPIBillableHoursForm');

function mapStateToProps(state) {  
  ////////////////// 
  let showTrendChart = selector(state,'ShowTrendChart');
  let showDisplayAverage = selector(state,'ShowDisplayAverage');
  return {
    showTrendChart,
    showDisplayAverage,

  ///////////////////
    dataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationBillableHoursGraph : {},    
    RightPanel_loading: state.staff_dashboard.RightPanel_loading,
  };
}

export default connect(mapStateToProps, { getOrganizationBillableHoursGraph })(KPIBillableHours);



// WEBPACK FOOTER //
// ./src/adminCharts/KPIBillableHours.js